<template>
  <div class="search">
    <van-search 
      :placeholder="placeholder" 
      v-model="keyword" 
      shape="round"
      left-icon=""
      @focus="goToSearch">
      <div slot="label" v-if="type == 'positions'">
        <van-dropdown-menu>
          <van-dropdown-item :title="functionName || '职能'" ref="functionItem">
            <van-tree-select
              :items="positionTitle"
              :active-id.sync="positionTitleIds"
              :main-active-index.sync="activeIndex"
              @click-item="selectFunctions"
            />
            <div class="operation">
              <div class="reset" @click="resetFunctions">重置</div>
              <div class="confirm" @click="confirm">确定</div>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </van-search>
  </div>
</template>

<script>

  import data from '@/common/data'
  import {getPositionTitle} from '@/api/positions'

export default {
  name: "search",
  props: {
    placeholder: {
      default: '请输入职位/公司名/职位ID'
    },
    type: {

    }
  },
  data(){
    return {
      keyword: this.$route.query.query || '',
      functionName: '',
      positionTitleIds: 0,
      activeIndex:0,
      positionTitle: [],
      params: {},
      temp: ''
    }
  },
  methods: {
    confirm(){
      let params = {...this.$route.query};
      delete params.companyId;
      params.positionTitleIds = this.positionTitleIds;
      delete params.companyId;
      if(!this.positionTitleIds)
        delete params.positionTitleIds;

      this.$refs.functionItem.toggle(false);
      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    resetFunctions(){
      this.functionName = '';
      this.positionTitleIds = 0;
      this.positionTitle.forEach(item=>{
        item.info = null;
      })
    },
    goToSearch(){
      let from = this.$route.name;
      this.$router.push({name: 'search', query: {...this.$route.query, from}});
    },
    selectFunctions(data){
      if(data.id == this.positionTitleIds)
        return;

      this.functionName = data.text == '不限' ? data.displayName : data.text;
      this.positionTitle.forEach((item,index)=>{
        let info = 0;
        item.children.forEach(ch=>{
          if(ch.id == data.id){
            info++;
          }
        })
        item.info = info ? info : null;
      })
    },
    init(){
      getPositionTitle({hasPositionTotal: true}).then(res=>{
        if(res&&res.data){

          res.data.positionTitleList = res.data.positionTitleList
              ? res.data.positionTitleList.splice(0, 5)
              : [];

          // let other = {
          //   groupId: null,
          //   id: "",
          //   industryId: "",
          //   isHot: false,
          //   name: "其他",
          //   parentId: 0,
          //   positionTotal: 70,
          //   type: 0,
          //   list: [
          //     { id: 108003, name: "采购/供应链", type: 1 },
          //     { id: 104001, name: "策划推广", type: 1 },
          //     { id: 108004, name: "投融资", type: 1 },
          //     { id: 117005, name: "交互设计", type: 1 },
          //     { id: 114002, name: "项目管理", type: 1 }
          //   ]
          // };

          // res.data.positionTitleList.push(other);

          let positionTitleList = res.data.positionTitleList || [];

          positionTitleList.forEach(pt=>{
            pt.text = pt.name;
            pt.info = null;
            pt.list = pt.list || [];
            pt.list = pt.list.filter(item=>!item.type);
            pt.list.unshift({
              id: pt.id,
              name: '不限',
              displayName: pt.name
            });
            let children = pt.list;
            children.forEach(ch=>{
              ch.text = ch.name;
              if(this.$route.query.positionTitleIds == ch.id){
                this.functionName = ch.name == '不限' ? ch.displayName : ch.name;
                pt.info = 1;
              }
            })
            pt.children = children;
          })

          this.positionTitle = positionTitleList;
          this.positionTitleIds = ~~this.$route.query.positionTitleIds || 0;
        }
      }).catch(err=>{})
    }
  },
  created(){
    this.init()
  }
};

</script>


<style scoped lang="scss">
 .search{
    .operation{
      display: flex;
      div{
        font-size: 14px;
        color: #333;
        flex-grow: 1;
        height: 45px;
        line-height: 45px;
        text-align: center;
        &.confirm{
          background: #22BAA5;
          color: #fff;
        }
        &.reset{
          box-shadow: inset 0 1px 0 0 #ddd;
        }
      }
    }
 }
</style>

<style lang="scss">
  .search{
    .van-sidebar-item--select{
      border-color: #22BAA5;
    }
    .van-tree-select__item--active{
      color: #22BAA5;
    }
    .van-tree-select__selected{
      color: #22BAA5;
    }
    .van-dropdown-item__content{
      max-height: 85%;
    }
    .van-search{
      padding: 7px 10px;
      .van-cell{
        padding: 3px 8px 3px 0;
      }
    }
    .van-dropdown-menu{
      height: 30px;
      background-color: inherit;
    }
    .van-dropdown-menu__title{
      .van-ellipsis{
        max-width: 30px;
      }
    }
    .van-search__label{
      padding: 0 15px 0 10px;
      margin-right: 10px;
      position: relative;
      line-height: 30px;
      &:after{
        content: " ";
        position: absolute;
        right: 0;
        top: 50%;
        width: 1px;
        height: 40%;
        background-color: #e5e5e5;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      };
    }
    .van-tree-select__item{
      
    }
  }
</style>
